import { create } from 'zustand';
import { AppRole, UI_CONTEXT_THEMES } from '@/shared/theme/tokens';

interface RoleState {
  activeRole: AppRole;
  setActiveRole: (role: AppRole) => void;
  getTheme: () => typeof UI_CONTEXT_THEMES[keyof typeof UI_CONTEXT_THEMES];
}

const getInitialRole = (): AppRole => {
  if (typeof globalThis !== 'undefined' && (globalThis as any).location?.pathname?.startsWith('/pro')) {
    return 'PROFESSIONAL';
  }
  return 'CONSUMER';
};

export const useRoleStore = create<RoleState>((set, get) => ({
  activeRole: getInitialRole(),
  setActiveRole: (role: AppRole) => set({ activeRole: role }),
  getTheme: () => UI_CONTEXT_THEMES[get().activeRole],
}));
